import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import AiChatModal from "components/ai_chat/AiChatModal";
import AiChatPanel from "components/ai_chat/AiChatPanel";
import Button from "components/ui/button/Button";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { settingsRoutes } from "lib/routes";

type Props = {
  resourceId: string;
  resourceName: string;
  noticeTitle?: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function AskStotlesAiModal({ resourceId, resourceName, isOpen, onClose }: Props) {
  const { colors } = useTheme();

  return (
    <AiChatModal isOpen={isOpen} onClose={onClose}>
      <AiChatPanel
        resourceId={resourceId}
        resourceName={resourceName}
        resourceType="BID_ASK_AI"
        suggestedQuestionsLayout="vertical"
        uiText={{
          subtitle:
            "Ask questions about the underlying tender documents you uploaded to this bid / no-bid report. Stotles AI will sort through the sources and provide clarity.",
          inputPlaceholder: "Ask me a question about this opportunity",
        }}
        suggestedQuestions={[
          {
            title: "Financial requirements",
            prompt:
              "Search the documents for mentions of financial standing, financial requirements, financial risk, or economic standing. Provide context and details about any financial criteria or assessments mentioned.",
          },
          {
            title: "Main contacts",
            prompt:
              "Review all documents and return the names, contact details and roles of all the main contacts for this tender.",
          },
        ]}
        renderSaveQuestion={() => {
          return (
            <SaveQuestionContainer>
              <Flex gap={8} alignItems="center">
                <UIcon icon="infoCircle" size={20} color={colors.sysPrimaryDefault} />
                <Text>Save this question for future reports?</Text>
              </Flex>
              <Button
                as="a"
                buttonType="tertiary"
                target="_blank"
                href={settingsRoutes.bidSelfServe}
              >
                Add bid / no-bid criteria
              </Button>
            </SaveQuestionContainer>
          );
        }}
      />
    </AiChatModal>
  );
}

const SaveQuestionContainer = styled(Flex)(({ theme }) => ({
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  borderRadius: 4,
  justifyContent: "space-between",
  padding: "10px 16px",
  alignItems: "center",
}));
